import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FaSignInAlt, FaUserPlus, FaRocket } from "react-icons/fa";
import { useTheme } from "../Theme/ThemeContext";

export default function AuthPromptModal({ show, onClose }) {
    const navigate = useNavigate();
    const { currentTheme } = useTheme();

    if (!show) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50 px-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.9, y: 20 }}
                animate={{ opacity: 1, scale: 1, y: 0 }}
                exit={{ opacity: 0, scale: 0.9, y: 20 }}
                transition={{ duration: 0.2 }}
                className="glass rounded-3xl shadow-2xl border border-white/20 dark:border-white/10 p-8 max-w-md w-full text-center relative overflow-hidden"
            >
                {/* Background decoration */}
                <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-to-br from-accent-100 to-emerald-100 dark:from-accent-900/20 dark:to-emerald-900/20 rounded-full filter blur-3xl opacity-50 -translate-y-1/2 translate-x-1/2"></div>
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-gradient-to-br from-accent-100 to-emerald-100 dark:from-accent-900/20 dark:to-emerald-900/20 rounded-full filter blur-3xl opacity-40 translate-y-1/2 -translate-x-1/2"></div>
                
                {/* Icon */}
                <div className={`w-20 h-20 bg-gradient-to-br ${currentTheme.colors.gradient} rounded-2xl flex items-center justify-center mx-auto mb-6 shadow-lg ${currentTheme.colors.glow} relative`}>
                    <FaRocket className="w-10 h-10 text-white" />
                    <div className="absolute -top-1 -right-1 w-5 h-5 bg-green-500 rounded-full border-2 border-white"></div>
                </div>

                {/* Text */}
                <h2 className="text-2xl font-bold text-neutral-900 dark:text-white mb-2">Login required</h2>
                <p className="text-neutral-600 dark:text-neutral-300 mb-8">
                    Please login or signup to access Code Arena content.
                </p>

                {/* Buttons */}
                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate("/login")}
                        className={`flex-1 flex items-center justify-center gap-2 py-3 px-6 rounded-xl font-semibold text-white bg-gradient-to-r ${currentTheme.colors.gradient} hover:opacity-90 shadow-lg ${currentTheme.colors.glow} hover:shadow-xl transition-all duration-300 hover:scale-[1.02]`}
                    >
                        <FaSignInAlt className="w-4 h-4" />
                        Login
                    </button>
                    <button
                        onClick={() => navigate("/signup")}
                        className="flex-1 flex items-center justify-center gap-2 py-3 px-6 rounded-xl font-semibold text-neutral-700 dark:text-neutral-200 glass border-2 border-neutral-200 dark:border-neutral-600 hover:border-accent-500 hover:text-accent-600 dark:hover:text-accent-400 transition-all duration-300"
                    >
                        <FaUserPlus className="w-4 h-4" />
                        Signup
                    </button>
                </div>
            </motion.div>
        </div>
    );
}
